/**
 * For posting a new appointment
 */
import { state } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations.js";
import { actions } from "./actions";

export default {
  state,
  getters,
  mutations,
  actions
};
